import { Alert } from '@/components'

type TExitSurveyAlert = {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
}

export default function ExitSurveyAlert({ isOpen, onClose, onSubmit }: Readonly<TExitSurveyAlert>) {
  return (
    <Alert
      title='Exit Survey?'
      description='Your responses and progress will be discarded and you must continue survey from the beginning.'
      buttonTitle='Exit Survey'
      backButtonTitle='Cancel'
      isError
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
